module.exports = __webpack_public_path__ + "static/route-line-e9c211f8030ffd29362f16879aafdb01.png";